import type * as api from '@gitbook/api-client';
import { Button } from '@gitbook/spine-react';

/**
 * Editor for the inherit merge rule configuration.
 */
export function MergeRulesInheritEditor(_props: {
    configuration: api.MergeRulesConfigurationInherit;
    onChange: (configuration: api.MergeRulesConfigurationInherit) => void;
}) {
    return (
        <div className="flex flex-row gap-3">
            <Button
                kind="secondary"
                label="Edit organization merge rule"
                href={{
                    screen: {
                        type: 'org_settings',
                        tab: {
                            type: 'rules',
                        },
                    },
                }}
            />
        </div>
    );
}
